module.exports = __webpack_public_path__ + "media/images/w_4-dd35c192c784cddd373eeeae60af83ed.png";